<tyl-kendo-pdf-export keepTogether="tr" class="tylKendoPdf">
	<!-- Header -->
	<div #studentHeader>
		<student-header [pageTitle]="'Student Fields'" [showYearSelector]="true" class="flex-header"></student-header>
	</div>
	<!-- Content -->
	<div class="flex-content">
		<div style="display: flex; flex-direction:row;flex:1;">
			<div style="display: flex; flex-direction:column;width:200px;flex:0.1;">
				<div>
					<table style="width:100%;background-color:white;" aria-label="Student Field Tab Selection">
						<tr *ngFor="let tab of StudentField.TabMenus" tabindex="0">
							<td style="padding:5px;border:2px solid #e3e3e3;border-right:none;cursor: pointer;"
								[ngStyle]="{'background-color':StudentField.SelectedTabId==tab.TabId? '#e8eaf6': ''}"
								(click)="menuSelected(tab.TabId)">
								{{tab.TabTitle}}
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div style="display: flex; flex-direction:column;flex:0.9;">
				<div #divUserDefinedField id="divUserDefinedField" class="removePrintHeight"
					[ngStyle]="{'overflow': 'auto', 'height': tableHeight + 'px'}">
					<div style="margin:10px;">
						<b class="modal-headerTitle" style="font-size:14pt;">{{getTabTitle()}}</b>
					</div>
					<table>
						<tr *ngFor="let row of tabRows(); let i = index;">
							<td *ngFor="let field of filterStudentField(1,row); let j = index;"
								style="padding:15px 2px 2px 2px;vertical-align: top;"
								[ngStyle]="{'text-align' : (field.NumberColumnUsed == 2 && field.Alignment == 1) ? 'left' : ((field.NumberColumnUsed == 2 && field.Alignment == 2) ? 'center' : 'right')}"
								attr.colspan="{{(field.ObjectType == 3 && field.NumberColumnUsed == 2)? 2 : 1}}">
								<span>{{field.FieldName}}</span>
							</td>

							<td style="padding:2px;" *ngFor="let field of filterStudentField(1,row); let j = index;"
								[ngStyle]="{'display':field.ObjectType == 3 && field.NumberColumnUsed == 2?'none':''}">
								<div>
									<div *ngIf="field.ObjectType != 3">
										<div
											*ngIf="field.DataFieldFormatType == 4 && field.ObjectType != 2 && field.Visible">
											<table>
												<tr>
													<td style="vertical-align:middle;">
														<tyl-datepicker id="FieldData{{field.DataFieldId}}"
															showLabelAsHint="true" [disabled]="!field.Editable"
															style="width: 150px" [(value)]="field.ColumnData"
															[(ngModel)]="field.ColumnData"
															(valueChange)="changeFieldData(field)"
															(change)="validateDate('FieldData',true, field)">
														</tyl-datepicker>
													</td>
													<td style="vertical-align:middle;padding-left:5px;">
														<span id="spanFieldData{{field.DataFieldId}}"
															style="background-color:#A20000;color:white;;font-weight:normal;;left:10px;display:none;"
															translate>
															Invalid date!
														</span>
													</td>
												</tr>
											</table>
										</div>
										<div
											*ngIf="field.DataFieldFormatType == 3 && field.ObjectType != 2 && field.Visible && !field.DataTypeFormat">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text"
													[disabled]="!field.Editable" mask="9*.9*"
													[(ngModel)]="field.ColumnData" (change)="changeFieldData(field)"
													[attr.maxlength]="field.FieldSize" />

											</tyl-form-field>
										</div>
										<div
											*ngIf="(field.DataFieldFormatType == 3 || field.DataFieldFormatType == 201 || field.DataFieldFormatType == 202 || field.DataFieldFormatType == 203) && field.ObjectType != 2 && field.Visible && field.DataTypeFormat">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text"
													[disabled]="!field.Editable" mask="9*"
													[(ngModel)]="field.ColumnData" [attr.maxlength]="field.FieldSize"
													(change)="changeFieldData(field)" />
											</tyl-form-field>
										</div>
										<div
											*ngIf="(field.ObjectType == 4 || (field.DataFieldFormatType != 4 && field.DataFieldFormatType != 3 && field.DataFieldFormatType != 202 && field.DataFieldFormatType != 201 && field.DataFieldFormatType != 203 && field.ObjectType != 2)) && field.Visible">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}" type="text"
													[disabled]="((field.ObjectType == 4 || field.DataFieldFormatType == 201 || !field.Editable) ? true: false)"
													maxlength="{{field.FieldSize}}" size="{{field.FieldWidth}}"
													(change)="changeFieldData(field)" [(ngModel)]="field.ColumnData" />
											</tyl-form-field>
										</div>
										<div *ngIf="field.ObjectType == 2 && field.Visible">
											<tyl-form-field [ngStyle]="{'width': '225px'}">
												<mat-select id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" [disabled]="!field.Editable"
													[compareWith]="compareObjects" [(ngModel)]="field.ExternalDataId"
													(selectionChange)="changeFieldData(field)">
													<mat-option
														*ngFor="let fldOption of StudentField.FieldOptions | StudentFieldLookupPipe : {DataFieldId : field.DataFieldId}"
														[value]="fldOption.Id">{{fldOption.CodeDescription}}
													</mat-option>
												</mat-select>
											</tyl-form-field>
										</div>

										<div *ngIf="!field.Visible && field.ObjectType != 2">
											<tyl-form-field [ngStyle]="{'width': '100px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text" [disabled]="true"
													value="!!!!!!" />
											</tyl-form-field>
										</div>
										<div *ngIf="!field.Visible && field.ObjectType == 2">
											<tyl-form-field [ngStyle]="{'width': '225px'}">
												<mat-select id="FieldData{{field.DataFieldId}}"
													[value]="field.OptionSelected" [disabled]="true">
													<mat-option [value]="0">
														!!!!!
													</mat-option>
												</mat-select>
											</tyl-form-field>
										</div>
									</div>
								</div>
							</td>
							<td *ngIf="visibleMiddleColumn(row);" colspan="2" style="text-align:center;padding:2px;">
							</td>
							<td *ngFor="let field of filterStudentField(2,row); let j = index;"
								style="padding:15px 2px 2px 10px;vertical-align: top;"
								[ngStyle]="{'text-align' : (field.NumberColumnUsed == 2 && field.Alignment == 1) ? 'left' : ((field.NumberColumnUsed == 2 && field.Alignment == 2) ? 'center' : 'right')}"
								attr.colspan="{{(field.ObjectType == 3 && field.NumberColumnUsed == 2)? 2 : 1}}">
								{{field.FieldName}}
							</td>
							<td style="padding-left:2px;vertical-align:top;"
								*ngFor="let field of filterStudentField(2,row);let j = index;"
								[ngStyle]="{'display':field.ObjectType == 3 && field.NumberColumnUsed == 2?'none':''}">
								<div *ngIf="!(field.ObjectType == 3 && field.NumberColumnUsed == 2)">
									<div *ngIf="field.ObjectType != 3">
										<div
											*ngIf="field.DataFieldFormatType == 4 && field.ObjectType != 2 && field.Visible">
											<table>
												<tr>
													<td style="vertical-align:middle;">
														<tyl-datepicker id="FieldData{{field.DataFieldId}}"
															[disabled]="!field.Editable" style="width: 150px"
															[(value)]="field.ColumnData" [(ngModel)]="field.ColumnData"
															(valueChange)="changeFieldData(field)"
															(change)="validateDate('FieldData',true, field)">
														</tyl-datepicker>
													</td>
													<td style="vertical-align:middle;padding-left:5px;">
														<span id="spanFieldData{{field.DataFieldId}}"
															style="background-color:#A20000;color:white;;font-weight:normal;;left:10px;display:none;"
															translate>
															Invalid date!
														</span>
													</td>
												</tr>
											</table>
										</div>
										<div
											*ngIf="field.DataFieldFormatType == 3 && field.ObjectType != 2 && field.Visible && !field.DataTypeFormat">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text"
													[(ngModel)]="field.ColumnData" mask="9*.9*"
													(change)="changeFieldData(field)" [attr.maxlength]="field.FieldSize"
													[disabled]="!field.Editable" />

											</tyl-form-field>
										</div>
										<div
											*ngIf="(field.DataFieldFormatType == 3 || field.DataFieldFormatType == 201 || field.DataFieldFormatType == 202 || field.DataFieldFormatType == 203) && field.ObjectType != 2 && field.Visible && field.DataTypeFormat">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text"
													[disabled]="!field.Editable" mask="9*"
													[(ngModel)]="field.ColumnData" [attr.maxlength]="field.FieldSize"
													(change)="changeFieldData(field)" />
											</tyl-form-field>
										</div>
										<div
											*ngIf="(field.ObjectType == 4 || (field.DataFieldFormatType != 4 && field.DataFieldFormatType != 3 && field.DataFieldFormatType != 202 && field.DataFieldFormatType != 201 && field.DataFieldFormatType != 203 && field.ObjectType != 2)) && field.Visible">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text"
													[disabled]="((field.ObjectType == 4 || field.DataFieldFormatType == 201 || !field.Editable) ? true: false)"
													[attr.maxlength]="field.FieldSize" (change)="changeFieldData(field)"
													[(ngModel)]="field.ColumnData" />
											</tyl-form-field>
										</div>
										<div *ngIf="field.ObjectType == 2 && field.Visible">
											<tyl-form-field [ngStyle]="{'width': '225px'}">
												<mat-select id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" [disabled]="!field.Editable"
													[compareWith]="compareObjects" [(ngModel)]="field.ExternalDataId"
													(selectionChange)="changeFieldData(field)">
													<mat-option
														*ngFor="let fldOption of StudentField.FieldOptions | StudentFieldLookupPipe : {DataFieldId : field.DataFieldId}"
														[value]="fldOption.Id">{{fldOption.CodeDescription}}
													</mat-option>
												</mat-select>
											</tyl-form-field>
										</div>
										<div *ngIf="!field.Visible && field.ObjectType != 2">
											<tyl-form-field [ngStyle]="{'width': field.FieldWidth + 'px'}">
												<input matInput id="FieldData{{field.DataFieldId}}"
													name="FieldData{{field.DataFieldId}}" type="text" [disabled]="true"
													value="!!!!!!" />
											</tyl-form-field>
										</div>
										<div *ngIf="!field.Visible && field.ObjectType == 2">
											<tyl-form-field [ngStyle]="{'width': '225px'}">
												<mat-select id="FieldData{{field.DataFieldId}}"
													[value]="field.OptionSelected" [disabled]="true">
													<mat-option [value]="0">
														!!!!!
													</mat-option>
												</mat-select>
											</tyl-form-field>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</tyl-kendo-pdf-export>
<div #footer class="sis-app-footer">
	<div *ngIf="enableSave">
		<tyl-button id="saveButton" image="Save.png" label="Save" (clickEvent)="saveClick(true)" tabindex="0"
			style="float: right;"></tyl-button>
		<error-prompt [errorList]="errors" style="float: right;padding: 0px 10px;"> </error-prompt>
	</div>
</div>
